import SelectCustomerNotification from './SelectCustomerNotification';

export default SelectCustomerNotification;
